import { render, staticRenderFns } from "./tag-info.vue?vue&type=template&id=1fe62799&"
import script from "./tag-info.vue?vue&type=script&lang=js&"
export * from "./tag-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports